import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Layout from "../../../layout/Layout";
import Merchant from "../AgentSummary/Merchant/Merchant";

export default function AgentLeadReport() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <Loader />;
  }
  return (
    <Layout>
      <Merchant id="" />
    </Layout>
  );
}
